<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//amplify

//import { components } from 'aws-amplify-vue'

export default {
  name: 'App',
  components: {
    //...components
  }
}
</script>

<style>
html:root {
  --amazonOrange: #ff3366;
  --button-background-color: #ff3366;
  --green: #09baa6;
  --green-darker: #00a08e;
  --link-color: none;
}
body { margin: 0 !important; }

</style>
